import { useConsent } from '@tv2/ui-cmp/Cookiebot';
import { useUserInteractionTrack } from '@tv2/lib-offspring/hooks/tracking/useUserInteractionTrack';
import styles from './Disclaimer.module.css';

function Disclaimer() {
  const { hasResponse, getCookieBot } = useConsent();
  const year = new Date().getFullYear();
  const trackUserInteraction = useUserInteractionTrack();
  return (
    <ul className={styles.container}>
      <li>
        <a
          className={styles.link}
          target="_blank"
          href="http://privatliv.tv2.dk"
          onClick={() => {
            trackUserInteraction({
              data: { label: 'tv2play.footer.disclaimer.privatlivspolitik' },
            });
          }}
        >
          Privatlivspolitik
        </a>
      </li>
      {hasResponse && (
        <li>
          <button
            type="button"
            className={styles.button}
            onClick={() => {
              trackUserInteraction({
                data: { label: 'tv2play.footer.disclaimer.cookieindstillinger' },
              });
              getCookieBot().renew();
            }}
          >
            Cookie-indstillinger
          </button>
        </li>
      )}
      <li>&copy; {year} TV 2 DANMARK A/S</li>
    </ul>
  );
}

export default Disclaimer;
